import { BRANDING } from '@/lib/branding'

export function withTrailingSlash(base: string): string {
  return base.endsWith('/') ? base : `${base}/`
}

export function injectInstallMetadata(): void {
  const base = withTrailingSlash(import.meta.env.BASE_URL)

  const manifest = document.createElement('link')
  manifest.rel = 'manifest'
  manifest.href = `${base}manifest-${BRANDING.tenant}.webmanifest`
  document.head.appendChild(manifest)

  const touchIcon = document.createElement('link')
  touchIcon.rel = 'apple-touch-icon'
  touchIcon.sizes = '180x180'
  touchIcon.href = `${base}icons/${BRANDING.tenant}/apple-touch-icon.png`
  document.head.appendChild(touchIcon)

  const favicon = document.querySelector<HTMLLinkElement>('link#favicon')
  if (favicon) {
    const file = favicon.href.split('/').pop() ?? 'favicon-light.png'
    favicon.href = `${base}${file}`
  }
}
